import { render, staticRenderFns } from "./MyaliceConfig.vue?vue&type=template&id=2b078c02"
import script from "./MyaliceConfig.vue?vue&type=script&lang=js"
export * from "./MyaliceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports